import React from 'react'
import AboutHero from '../components/About/AboutHero'
import Footer from '../components/Footer'

function About() {
  return (
    <>
      <AboutHero />
      <hr className='h-line' />
      <Footer />
    </>
  )
}

export default About
